<modal-panel
  (close)="closeDialog()"
  data-testid="connexpay-vcc-payment-detail-modal-panel">

  <app-matching-vcc-payment-detail-report />

  <ng-container modalPanelFooter data-testid="connexpay-vcc-payment-detail-modal-panel-footer">
    <button mat-button mat-raised-button color="primary" (click)="closeDialog()" data-testid="connexpay-vcc-payment-detail-modal-panel-close-button">Close</button>
  </ng-container>

</modal-panel>
